import React from 'react';
import Product from './product/product';
import { AttraqtSuggestionsProduct } from '../../../../../../../types';
import popularProductsStyles from './popularProducts.module.pcss';
import { MessagePropertiesContext } from '../../../../../../../contexts/messageProperties';

interface PopularProductsProps {
  popularProducts: AttraqtSuggestionsProduct[];
}

function PopularProducts({ popularProducts }: PopularProductsProps): React.ReactElement {
  const [formattedMessage] = React.useContext(MessagePropertiesContext);

  return (
    <>
      <h3 className={popularProductsStyles['popular-products-heading']}>
        {formattedMessage({ id: 'search.dropdown.popularProducts', fallback: 'Popular products' })}
      </h3>
      <div className={popularProductsStyles.products}>
        {popularProducts.map((product) => (
          <div key={product.code} className={popularProductsStyles['products__product-wrapper']}>
            <Product product={product} />
          </div>
        ))}
      </div>
    </>
  );
}

export default PopularProducts;
